<div class="modal-body bk-clr-gradient">
    <div class="container">
        <div class="col-sm-12">
            <div class="row no-margin justify-content-center">
                <div class="modal-logo text-center mb-3">
                    <img src="/cpc-logo-black-1.png" alt="Logo" />
                </div>

                <div class="session-title text-center mb-3">
                    <div class="lock-icon"><i class="fa fa-lock" aria-hidden="true"></i></div>
                    <h4 class="hey">Hey <span class="session-username">{{userName | titlecase}}</span></h4>
                    <h5 class="border-0">Your session expired, please login again to continue</h5>
                </div>

                <form [formGroup]="loginForm" style="width: 100%;">
                    <div class="form-group col-sm-12">
                        <mat-form-field appearance="fill" class="full-width">
                            <mat-label>Password</mat-label>
                            <input matInput type="password" formControlName="password" />
                            <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
                                Password is required!
                            </mat-error>
                        </mat-form-field>
                    </div>
                </form>

                <div class="switch-account-container text-center mt-3">
                    <button type="button" (click)="ifLogin()" [disabled]="loginForm.invalid"
                        class="modal-confirm btns-modal-action fill-left-to-right">
                        SUBMIT
                    </button>
                    <br />
                    <a (click)="goToLogin()" class="text-primary mt-2 d-inline-block">Switch Accounts</a>
                </div>
            </div>
        </div>
    </div>
</div>